import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
import _imports_0 from '../assets/SpendingAnalysisImage.png';
const _hoisted_1 = {
    key: 0,
    class: "simplePage"
};
const _hoisted_2 = { class: "anchor-bottom" };
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FinancesFinishPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const about = ref(false);
        function onLoad() {
            getCustomer();
        }
        function finish() {
            router.replace({ path: '/linkopenbankingaccount' });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    bgcolor: "#00000000",
                    border: "0"
                }),
                (!about.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _cache[0] || (_cache[0] = _createElementVNode("h1", null, "See your spending in a whole new way", -1)),
                        _cache[1] || (_cache[1] = _createElementVNode("img", {
                            class: "largeHeroImg",
                            src: _imports_0
                        }, null, -1)),
                        _cache[2] || (_cache[2] = _createElementVNode("p", null, "Get insights into your daily spending and curate a personalised spending plan.", -1)),
                        _cache[3] || (_cache[3] = _createElementVNode("p", null, null, -1)),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(MGButton, {
                                alt: false,
                                text: "continue",
                                arrow: true,
                                onClick: finish
                            })
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
